export default function googleMapsWidget(editor) {
  editor.DomComponents.addType('eb-google-maps', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-google-maps'
    },
    model: {
      defaults: {
        name: 'Google Maps',
        tagName: 'div',
        droppable: false,
        attributes: {
          'data-gjs-type': 'eb-google-maps',
          'data-address': 'New York, NY',
          'data-zoom': '14',
        },
        style: {
          'position': 'relative',
          'padding-bottom': '56.25%',
          'height': '0',
          'overflow': 'hidden',
          'border-radius': '8px',
        },
        components: `<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;border:none;" src="https://maps.google.com/maps?q=New+York,+NY&z=14&output=embed" allowfullscreen loading="lazy"></iframe>`,
        traits: [
          { type: 'text', name: 'data-address', label: 'Address', changeProp: true },
          { type: 'number', name: 'data-zoom', label: 'Zoom (1-20)', min: 1, max: 20, default: 14 },
          { type: 'number', name: 'data-height', label: 'Height (px)', default: 400 },
        ],
      },
      init() {
        this.on('change:attributes:data-address', this.updateMap)
        this.on('change:attributes:data-zoom', this.updateMap)
      },
      updateMap() {
        const addr = encodeURIComponent(this.getAttributes()['data-address'] || 'New York, NY')
        const zoom = this.getAttributes()['data-zoom'] || '14'
        this.components(`<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;border:none;" src="https://maps.google.com/maps?q=${addr}&z=${zoom}&output=embed" allowfullscreen loading="lazy"></iframe>`)
      },
    },
  })

  editor.BlockManager.add('eb-google-maps', {
    label: 'Google Maps',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"/></svg>',
    content: { type: 'eb-google-maps' },
  })
}
